import React from 'react'
import PropTypes from 'prop-types'

export const PageTitleUnstyled = props => (
  <h1 className={props.className}>{props.children}</h1>
)

PageTitleUnstyled.propTypes = {
  pathname: PropTypes.string,
}

PageTitleUnstyled.defaultProps = {
  pathname: '',
}
